export default "__VITE_ASSET__BoWl26bv__"